module.exports = __webpack_public_path__ + "img/abnormal.341886f2.png";